import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { useSelector, useDispatch } from 'react-redux'

import {
  checkPurchaseWalletRequestAction,
  uncheckPurchaseWalletRequestAction,
  fetchWalletRequestAction,
  fetchAppliedWalletRequestAction,
} from 'client/contexts/Wallet/actions'

import { useSystem } from 'src/hooks/useSystem'
import { getLoginStatus } from 'client/contexts/Login/selectors'
import { isCheck, getWalletCredit, isFetching } from 'client/contexts/Wallet/selectors'

import Price from 'client/components/Price'
import Checkbox from 'src/comps/Checkbox'

import { CheckoutWalletSelectorBase } from './styles'
import messages from './messages'

const CheckoutWalletSelector = ({ purchaseId }) => {
  const dispatch = useDispatch()
  const { apiHostName } = useSystem()

  const [firstCheckDone, setFirstCheckDone] = useState(false)
  const { amount, currency } = useSelector(getWalletCredit)
  const isLoading = useSelector(isFetching)
  const isLogged = useSelector(getLoginStatus)
  const isWalletChecked = useSelector(isCheck)

  function onChange() {
    if (isLoading) {
      return
    }

    if (isWalletChecked) {
      dispatch(
        uncheckPurchaseWalletRequestAction({
          hostname: apiHostName,
          data: { purchaseId },
        })
      )
      return
    }

    dispatch(
      checkPurchaseWalletRequestAction({
        hostname: apiHostName,
        data: { purchaseId },
      })
    )
  }

  useEffect(() => {
    if (isLogged) {
      dispatch(
        fetchWalletRequestAction({
          hostname: apiHostName,
          data: { purchaseId },
        })
      )
    }
  }, [purchaseId, isLogged]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (isLogged && amount && !firstCheckDone) {
      dispatch(
        fetchAppliedWalletRequestAction({
          hostname: apiHostName,
          data: { purchaseId },
        })
      )
      setFirstCheckDone(true)
    }
  }, [amount]) // eslint-disable-line react-hooks/exhaustive-deps

  if (!amount || !isLogged) {
    return null
  }

  return (
    <CheckoutWalletSelectorBase data-testid="checkout-wallet-selector" onClick={onChange}>
      <Checkbox name="staywallet" selected={isWalletChecked} onChange={() => {}} />
      <FormattedMessage {...messages.useMyCredit} tagName="p" />

      <span>
        <Price amount={-amount} currency={currency} />
      </span>
    </CheckoutWalletSelectorBase>
  )
}

CheckoutWalletSelector.propTypes = {
  purchaseId: PropTypes.string.isRequired,
}

export default CheckoutWalletSelector
